export async function postJson(url, { token, body } = {}) {
  const headers = {}
  if (token) headers.Authorization = `Bearer ${token}`
  if (body !== undefined) headers['Content-Type'] = 'application/json'

  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: body === undefined ? undefined : JSON.stringify(body)
  })

  const data = await response.json().catch(() => ({}))
  if (!response.ok) {
    const error = new Error(data?.message || response.statusText || 'Request failed')
    error.status = response.status
    error.code = data?.code
    throw error
  }
  return data
}

export function demoLogin({ apiOrigin, appId, agentId }) {
  return postJson(
    `${apiOrigin}/v1/apps/${appId}/ai_agents/${agentId}/voice/demo_login`
  )
}

export function startConversation({ apiOrigin, agentId, token, userId }) {
  return postJson(`${apiOrigin}/v1/ai_agents/${agentId}/voice/conversations`, {
    token,
    body: { user_id: userId }
  })
}
